import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../../../../../../../init-store';
import { isRoomAgentMode, selectRoomAgentCanToggleVideo } from '../../../../../../../shared/features/config/selectors';
import { selectModalType } from '../../../../../../../shared/features/room-agent/dtmf/modal-type/selectors';
import {
    selectIsSelfAudioMuted,
    selectIsSelfVideoMuted,
} from '../../../../../../../shared/features/room-agent/dtmf/selectors';
import { selectIsAnyRecordingActive, selectSelfReactionType, selectWaitingRoomIsEmpty } from '../../../../../selectors';
import { selectIsSummarizationRunning } from '../../../../summarization/selectors';
import { getActiveNotificationTypes } from './helpers';
import { NotificationTypeId } from './types';

/**
 * Можно ли показывать нотификации
 * Условия: roomAgent mode активен И модальные окна закрыты
 */
export const selectCanShowNotifications = createSelector(
    isRoomAgentMode,
    selectModalType,
    (inRoomAgentMode, modalType) => inRoomAgentMode && modalType === null
);

/**
 * Возвращает мемоизированный массив активных типов нотификаций.
 */
export const selectActiveNotificationTypes = (state: RootState): NotificationTypeId[] => {
    if (!selectCanShowNotifications(state)) {
        return [];
    }

    return getActiveNotificationTypes({
        micMuted: selectIsSelfAudioMuted(state),
        cameraMutedForNotification: selectIsSelfVideoMuted(state) && selectRoomAgentCanToggleVideo(state),
        reactionType: selectSelfReactionType(state),
        waitingRoomEmpty: selectWaitingRoomIsEmpty(state),
        summarizationRunning: selectIsSummarizationRunning(state),
        recordingActive: selectIsAnyRecordingActive(state),
    });
};
